import React, { ChangeEvent, FormEvent } from 'react';
import { CORPORATE_SEARCH, Icon, Input } from '@vodafoneziggo/sandwich';
import { useContainer } from 'unstated-next';
import { SearchTermContainer } from 'containers/Other/SearchTerm.container';
import * as S from './searchBar.styles';

export interface OnSearchSubmitProps {
  searchTerm: string;
}

interface SearchBarProps {
  label: string;
  onChangeEvent?: (searchTerm: string) => void;
  onSearchSubmit?: ({ searchTerm }: OnSearchSubmitProps) => void;
  testId?: string;
  hideSubmitButton?: boolean;
}

export const SearchBar = ({
  label,
  onChangeEvent,
  onSearchSubmit,
  testId,
  hideSubmitButton = false,
}: SearchBarProps) => {
  const { searchTerm, setSearchTerm } = useContainer(SearchTermContainer);

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    onSearchSubmit && onSearchSubmit({ searchTerm });
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    onChangeEvent && onChangeEvent(event.target.value);
  };

  return (
    <S.Form onSubmit={onSubmit} data-testid={`search${testId ? `-${testId}` : ''}`}>
      <Input value={searchTerm} onChange={onChange} placeholder={label} type="text" testId="searchTermInput" />
      {!hideSubmitButton && (
        <S.Submit type="submit">
          <Icon icon={CORPORATE_SEARCH} height="1.5rem" width="1.5rem" />
        </S.Submit>
      )}
    </S.Form>
  );
};
